import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { isEmpty, isEqual } from 'lodash'
import Button from '@mui/material/Button';
import { useGetVcodeMutation, useRegisterMutation } from 'config/api/waV1_user'
import { toggleNoti, toggleError } from 'config/slice/message'
import {
    TYPE_EMAIL,
    TYPE_EMAIL_VCODE,
    TYPE_PASSWORD,
    TYPE_PASSWORD_VERIFY,
    TYPE_PHONE
} from 'config/const/type'
import {
    KEY_ERROR_EMAIL_NOT_FILL,
    KEY_ERROR_EMAIL_VCODE_NOT_FILL,
    KEY_ERROR_PASSWORD_CONFIRM_NOT_FILL,
    KEY_ERROR_PASSWORD_NOT_FILL,
    KEY_ERROR_PHONE_NOT_FILL,
    KEY_ERROR_PWD_NOT_SAME,
    KEY_ERROR_REG_FAILED,
    KEY_TEXT_BTN_LOGIN,
    KEY_TEXT_BTN_REG,
    KEY_TEXT_BTN_VCODE,
    KEY_TEXT_IPT_EMAIL,
    KEY_TEXT_IPT_EMAIL_VCODE,
    KEY_TEXT_IPT_PHONE,
    KEY_TEXT_IPT_PWD,
    KEY_TEXT_IPT_PWD_CONFIRM,
    KEY_TEXT_REG_SUCC,
    MODULE_REG
} from 'config/const/locale'
import { getCookie, setCookie } from 'utils/cookies'
import { COOKIE_TOKEN, STORAGE_USER_PATHNAME, STORAGE_USER_PROFILE } from 'config/const/global'
import { tokenHandler, userProfileSetter } from 'config/slice/global'

const TIMER = 60

const to = getCookie(STORAGE_USER_PATHNAME)

export default function Reg() {

    const [iptValue, setIptValue] = useState({
        [TYPE_EMAIL]: '',
        [TYPE_EMAIL_VCODE]: '',
        [TYPE_PHONE]: '',
        [TYPE_PASSWORD]: '',
        [TYPE_PASSWORD_VERIFY]: '',
    }) // inputs' value
    const [sendVcode, setSendVcdoe] = useState(false)
    const [sent, setSent] = useState(false)
    const [countdown, setCountdown] = useState(TIMER)
    const [regFn] = useRegisterMutation() // login API from RTKQ
    const [getVcodeFn] = useGetVcodeMutation() // login API from RTKQ
    const dispatch = useDispatch() // redux method manipulating the state
    const { t } = useTranslation(MODULE_REG) // i18n hook, i18n.changeLanguage('en') method to change language
    const navigate = useNavigate() // navigator
    const { lng } = useSelector(state => state.global)

    /**
     * handle inputs relating to login
     * @param {String} type input's type and key
     */
    const iptHandler = (type) => (e) => setIptValue(prev => ({ ...prev, [type]: e.target.value }))

    const vcodeHandler = () => {
        setSent(true)
        setCountdown(TIMER)
        window.timer = setInterval(() => setCountdown(p => (p - 1)), 1000);
        getVcodeFn({
            email: iptValue[TYPE_EMAIL],
            lng
        })
            .then(
                res => {
                    if (res.data?.status && res.data.status == 200) { }
                    else {
                        toggleError({
                            indicator: true,
                            msg: res.data.message
                        })
                    }
                }
            )
            .catch(
                reason => {
                    console.log(reason)
                }
            )
    }

    // login btn handler, data checking and msg noticing
    const regHandler = () => {

        if (isEmpty(iptValue[TYPE_EMAIL])) { // check account input's value, return if empty
            dispatch(toggleError({
                indicator: true,
                msg: t(KEY_ERROR_EMAIL_NOT_FILL)
            }))
            return
        }
        if (isEmpty(iptValue[TYPE_EMAIL_VCODE])) { // check account input's value, return if empty
            dispatch(toggleError({
                indicator: true,
                msg: t(KEY_ERROR_EMAIL_VCODE_NOT_FILL)
            }))
            return
        }
        if (isEmpty(iptValue[TYPE_PHONE])) { // check account input's value, return if empty
            dispatch(toggleError({
                indicator: true,
                msg: t(KEY_ERROR_PHONE_NOT_FILL)
            }))
            return
        }
        if (isEmpty(iptValue[TYPE_PASSWORD])) { // check account input's value, return if empty
            dispatch(toggleError({
                indicator: true,
                msg: t(KEY_ERROR_PASSWORD_NOT_FILL)
            }))
            return
        }
        if (isEmpty(iptValue[TYPE_PASSWORD_VERIFY])) { // check password input's value, return if empty
            dispatch(toggleError({
                indicator: true,
                msg: t(KEY_ERROR_PASSWORD_CONFIRM_NOT_FILL)
            }))
            return
        }
        if (!isEqual(iptValue[TYPE_PASSWORD], iptValue[TYPE_PASSWORD_VERIFY])) { // check password input's value, return if empty
            dispatch(toggleError({
                indicator: true,
                msg: t(KEY_ERROR_PWD_NOT_SAME)
            }))
            return
        }

        regFn(iptValue)
            .then( // save login token, set cookie and send noti if succeed, otherwise set error msg and return
                result => {
                    if (result.data?.status && result.data.status == 200) {
                        dispatch(tokenHandler({
                            switch: true,
                            newToken: result.data.data.token
                        }))
                        dispatch(userProfileSetter(result.data.data.user))
                        setCookie(STORAGE_USER_PROFILE, JSON.stringify(result.data.data.user))
                        setCookie(COOKIE_TOKEN, result.data.data.token)
                        dispatch(toggleNoti({
                            indicator: true,
                            msg: t(KEY_TEXT_REG_SUCC)
                        }))
                        navigate(to, { replace: true })
                    } else {
                        dispatch(toggleError({
                            indicator: true,
                            msg: result.error?.data?.message?.message || t(KEY_ERROR_REG_FAILED)
                        }))
                    }
                }
            )


    }

    useEffect(() => {
        if (iptValue[TYPE_EMAIL] == '') {
            setSendVcdoe(false)
        } else {
            setSendVcdoe(true)
        }
    }, [iptValue])

    useEffect(() => {
        if (countdown <= 0) {
            setSent(false)
            clearInterval(window.timer)
            return
        }
    }, [countdown])

    return (
        <div className='wa-fullscreen wa-bg-login'>

            <div className="login-box position-fixed start-50 top-50 translate-middle">
                <div className="card wa-light-blue wa-rounded-2rem overflow-hidden">
                    <div className="card-header">
                        <div className="link-dark text-center link-offset-2 link-opacity-100 link-opacity-50-hover text-white wa-light-blue">
                            <h1 className='fs-3 p-3'>
                                {t(KEY_TEXT_BTN_REG)}
                            </h1>
                        </div>
                    </div>
                    <div className="card-body login-card-body">
                        <form>
                            <div className="input-group mb-1">
                                <div className="form-floating col-11 p-0 wa-h-5rem">
                                    <input id="regEmail" type="email" className="form-control wa-h-5rem fs-4 ps-4 border-secondary wa-rounded-start" placeholder="" onChange={iptHandler(TYPE_EMAIL)} />
                                    <label htmlFor="regEmail" className='fs-4 ps-4'>{t(KEY_TEXT_IPT_EMAIL)}</label>
                                </div>
                                <div className="input-group-text col-1 border-secondary wa-rounded-end">
                                    {/* <span className="bi bi-envelope"></span> */}
                                </div>
                            </div>
                            <div className="input-group my-4">
                                <div className="form-floating col-9 p-0 wa-h-5rem">
                                    <input id="emailvc" type="tel" className="form-control wa-h-5rem fs-4 ps-4 border-secondary wa-rounded-start" placeholder="" onChange={iptHandler(TYPE_EMAIL_VCODE)} />
                                    <label htmlFor="emailvc" className='fs-4 ps-4'>{t(KEY_TEXT_IPT_EMAIL_VCODE)}</label>
                                </div>
                                <div className="input-group-text col-3 border-secondary wa-rounded-end">
                                    {/* <span className="bi bi-envelope"></span> */}
                                    <Button
                                        variant="contained"
                                        disableRipple={sendVcode ? sent ? true : false : true}
                                        className={sendVcode ? sent ? 'wa-btn-disable' : '' : 'wa-btn-disable'}
                                        onClick={sendVcode ? sent ? () => { } : vcodeHandler : () => { }}
                                    >
                                        {
                                            sent ? countdown + 's' : t(KEY_TEXT_BTN_VCODE)
                                        }
                                    </Button>
                                </div>
                            </div>
                            <div className="input-group my-4">
                                <div className="form-floating col-11 p-0 wa-h-5rem">
                                    <input id="regp" type="tel" className="form-control wa-h-5rem fs-4 ps-4 border-secondary wa-rounded-start" placeholder="" onChange={iptHandler(TYPE_PHONE)} />
                                    <label htmlFor="regp" className='fs-4 ps-4'>{t(KEY_TEXT_IPT_PHONE)}</label>
                                </div>
                                <div className="input-group-text col-1 border-secondary wa-rounded-end">
                                    {/* <span className="bi bi-envelope"></span> */}
                                </div>
                            </div>
                            <div className="input-group my-4">
                                <div className="form-floating col-11 p-0 wa-h-5rem">
                                    <input id="regpwd" type="password" className="form-control wa-h-5rem fs-4 ps-4 border-secondary wa-rounded-start" placeholder="" onChange={iptHandler(TYPE_PASSWORD)} />
                                    <label htmlFor="regpwd" className='fs-4 ps-4'>{t(KEY_TEXT_IPT_PWD)}</label>
                                </div>
                                <div className="input-group-text col-1 border-secondary wa-rounded-end">
                                    {/* <span className="bi bi-lock-fill"></span> */}
                                </div>
                            </div>
                            <div className="input-group my-4">
                                <div className="form-floating col-11 p-0 wa-h-5rem">
                                    <input id="regrepwd" type="password" className="form-control wa-h-5rem fs-4 ps-4 border-secondary wa-rounded-start" placeholder="" onChange={iptHandler(TYPE_PASSWORD_VERIFY)} />
                                    <label htmlFor="regrepwd" className='fs-4 ps-4'>{t(KEY_TEXT_IPT_PWD_CONFIRM)}</label>
                                </div>
                                <div className="input-group-text col-1 border-secondary wa-rounded-end">
                                    {/* <span className="bi bi-lock-fill"></span> */}
                                </div>
                            </div>
                            {/* <!--begin::Row--> */}
                            <div className="row mb-4">
                                {/* <div className="col-8 d-inline-flex align-items-center">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                        <label className="form-check-label" htmlFor="flexCheckDefault">
                                            Remember Me
                                        </label>
                                    </div>
                                </div> */}
                                {/* <!-- /.col --> */}
                                <div className="col-12">
                                    <div className="d-grid gap-2" onClick={regHandler}>
                                        <a className="btn wa-light-blue text-white p-4 fs-4 rounded rounded-pill">{t(KEY_TEXT_BTN_REG)}</a>
                                    </div>
                                </div>
                                {/* <!-- /.col --> */}
                            </div>
                            {/* <!--end::Row--> */}
                        </form>
                        {/* <!-- /.social-auth-links --> */}
                        <p className="mb-1 text-center">
                            {/* <a href="#" className='text-decoration-underline text-secondary'>{t(KEY_TEXT_LINK_FORGET_PWD)}</a> */}
                            <Link to={'/login'} className='text-decoration-underline text-secondary'>{t(KEY_TEXT_BTN_LOGIN)}</Link>
                        </p>
                    </div>
                    {/* <!-- /.login-card-body --> */}
                </div>
            </div>
        </div>
    )
}
